export default __webpack_public_path__ + "static/media/douyin.45e95aeb.jpg";